import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { IgMedia, IgMetadataHashtag } from '@core/models/ApiFields/ig-entities';
import { Paginated } from '@core/models/IApi';
import {
    IG_ENDPOINT,
    postHashtagsFields,
} from '@features/social-analysis/social-listening/config/api-params';
import { HttpBuilder } from '../../social-shared/services/http/http-builder';
import { SingleHttpSubscription } from '../../social-shared/services/http/http-subscription';
import { DATA_STATUS } from '../../social-shared/store/state.store';

@Injectable({ providedIn: 'root' })
export class PostHashtagsHttpBuilder extends HttpBuilder {
    #subsHandler = new SingleHttpSubscription();

    reqHashtags(state: any, mediaId: string) {
        const url = this.buildUrl(IG_ENDPOINT);
        const params = this.buildParams(mediaId);

        state.isLoading.set(true);
        const http = this.http.get<Paginated>(url, { params });
        const sub = this.subscribeToHttp$(http, state);
        this.#subsHandler.httpSub = sub;
    }

    private buildParams(mediaId: string): Params {
        return {
            ...this.getFields(),
            ...this.getMediaIdFilter(mediaId),
        };
    }

    private getFields() {
        return { fields: postHashtagsFields.join() };
    }

    private getMediaIdFilter(mediaId: string) {
        return { [IgMedia.getPrefixed('mediaId')]: 'eq:' + mediaId };
    }

    protected override handleSuccess(state: any, data: any) {
        const hashtags = data[0][IgMetadataHashtag.getPrefixed('hashtags')];
        state.data.set(hashtags);
        state.dataStatus.set(DATA_STATUS.OK);
    }
}
